module.exports = __webpack_public_path__ + "img/ING.cac2389b.png";